import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    changeDate: {
        id: "homework.changeDate",
    },
    cancel: {
        id: "general.cancel",
    },
    modify: {
        id: "general.modify",
    },
    homeworkDate: {
        id: "homework.date",
    },
    homeworkStartDate: {
        id: "homework.startDate",
    },
});

export default messages;
